import React, {useEffect, useRef} from 'react';

//UI Fabric
import { ActionButton } from '@fluentui/react/lib/Button';
import { ValidationState, TagPicker as UIFabricTagPicker } from '@fluentui/react';
import { httpServiceSecureGet } from '../../common/Http';

//Custom Fabric UI
import { TooltipLabel } from '../TooltipLabel/';

const TagPickerComponent = props => {
  const {
    label,
    ariaLabel,
    disabled,
    input,
    id,
    elementName,
    onResolveUrl,
    authToken,
    onBlurFunction
  } = props;
  const tagPicker = useRef(null);

  useEffect( () => {
    if ( tagPicker?.current )
      setTimeout(() => tagPicker.current.focus(), 800);
  }, [tagPicker]);

  const _onResolveSuggestions = async (filterText, currentTags) => {
    if (filterText) {
      const { gtToken } = authToken;
      return new Promise(async (resolve, reject) => {
        const json = await httpServiceSecureGet(`${onResolveUrl}${filterText}`, gtToken);
        const tags: any[] = [];

        json.forEach((tag: any) => {
          tags.push(tag);
        });
        resolve(tags);

      }).then((tags: any[]) => {
        return tags.filter(tag => !_listContainsTags(tag, currentTags));
      });
    } else {
      return [];
    }
  };

  const _listContainsTags = (tag, currentTags): any => {
    if (!currentTags || !currentTags.length || currentTags.length === 0) {
      return false;
    }

    return (
        currentTags.filter(compareTag => compareTag.name === tag.name).length > 0
    );
  };

  const _onValidateInput = (name: string) => {
    const tag = {
      name
    };

    return _listContainsTags(tag, tagPicker.current.selection._items);
  };

  const _createGenericItem = (name: string, isValid: ValidationState) => {
    const tagName: string = name.trim();

    if (isValid || name === '') {
      return null;
    }

    const newTag: any = {
      key: '0',
      name: tagName
    };

    return newTag;
  };

  const _createItemOnClick = event => {
    event.preventDefault();
    event.stopPropagation();

    const name = tagPicker.current.input.current.value?.trim();

    if (name !== '') {
      tagPicker.current.addItem({
        id: 0,
        name
      });
      tagPicker.current.input.current._updateValue('');
    }
  };

  return (
    <>
      <TooltipLabel ariaLabel={ariaLabel} required={false} label={label}/>
      <div className='tagPicker-container'>
        <UIFabricTagPicker
          componentRef={ref => (tagPicker.current = ref)}
          pickerSuggestionsProps={{
            suggestionsHeaderText: 'Searched Tags',
            noResultsFoundText: 'No results found'
          }}
          disabled={disabled}
          onResolveSuggestions={_onResolveSuggestions}
          onChange={items => {
            console.log('items onChange', items);
            input.onChange(items);
          }}
          selectedItems={input.value}
          createGenericItem={_createGenericItem}
          onValidateInput={_onValidateInput}
          inputProps={{
            onBlur: onBlurFunction || null,
            id,
            name: elementName,
            'aria-label': ariaLabel
          }}
          resolveDelay={600}
        />
        <ActionButton
          className='govTeams-actionButton'
          onClick={_createItemOnClick}
          iconProps={{iconName: 'Add'}}
        >
          Add tag
        </ActionButton>
      </div>
    </>
  );
}

export default TagPickerComponent;
